<template>
  <b-container class="section-list">
    <draggable
      class="dragArea"
      v-model="questionnaire.sections"
      :options="{ group: 'sections' }"
      @update="orderSections"
    >
      <section-list-item
        v-for="section in questionnaire.sections"
        :key="section.id || section.uid"
        :section="section"
        :questionnaire="questionnaire"
        @delete-section="deleteSection"
        @update="orderQuestionSections"
        @add="orderQuestionSections"
        @delete-question-section="deleteQuestionSection"
      />
    </draggable>

    <b-button
      variant="info"
      size="sm"
      class="float-right m-2"
      @click="addSection()"
    >
      Add Section
    </b-button>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import maxBy from 'lodash/maxBy';
import draggable from 'vuedraggable';
import VueWait from 'vue-wait';
import SectionListItem from '@/components/questionnaire/SectionListItem';

export default {
  name: 'SectionList',
  components: {
    draggable,
    SectionListItem,
  },
  wait: new VueWait(),
  props: {
    questionnaire: Object,
  },
  methods: {
    orderSections: function() {
      const shownSections = this.questionnaire.sections.filter(
        (s) => !s.delete_me
      );
      shownSections.forEach((s, i) => {
        this.$set(s, 'order', i + 1);
      });
    },
    deleteSection: function(section) {
      this.$set(section, 'delete_me', !section.delete_me);
      this.orderSections();
    },
    addSection: function() {
      const order =
        (this.questionnaire.sections || []).length > 0
          ? maxBy(this.questionnaire.sections, (s) => s.order).order + 1
          : 1;
      this.questionnaire.sections.push({
        order,
        questionnaire_id: this.questionnaire.id,
        title: '[New Section]',
        visible: true,
        questionSections: [],
        is_module: 0,
        specialties: [],
        description: '',
        uid: Date.now(),
      });
    },
    orderQuestionSections: function() {
      this.questionnaire.sections.forEach((s) => {
        const shownQuestionSections = s.questionSections.filter(
          (qs) => !qs.delete_me
        );
        shownQuestionSections.forEach((qs, i) => {
          this.$set(qs, 'order', i + 1);
        });
      });
    },
    deleteQuestionSection: function(questionSection) {
      this.$set(questionSection, 'delete_me', !questionSection.delete_me);
      this.orderQuestionSections();
    },
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss" scoped>
.section-title-input {
  display: inline-block;
  width: 400px;
  font-weight: bold;
}
.question-header {
  max-width: 75%;
  margin-left: 100px;
  text-indent: -100px;
  .badge {
    text-indent: 0;
    margin-left: revert;
  }
  .question-id {
    padding: 0 10px;
  }
}
.custom-control-label::before,
.custom-control-label::after {
  top: 0.15rem;
}
</style>
